import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import {Observable, switchMap, take} from 'rxjs';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import { environment } from '../../environment/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private afAuth = inject(AngularFireAuth);


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (environment.bypassAuth) {
      return next.handle(request);
    }
    // On vérifie d'abord si l'URL de la requête contient '/public'
    if(request.url.includes('/public')) {
      // Si c'est le cas, on laisse la requête aller sans y toucher
      return next.handle(request);
    } else {
      return this.afAuth.idToken.pipe(
        // Cette requête nous retourne un flux infini de jetons (chaque fois que le jeton est
        // renouvelé par Firebase, un nouveau jeton est émis). On veut juste le premier de ce
        // flux, et c'est ce que fait le `take(1)`.
        take(1),
        // On utilise ensuite switchMap pour attendre que le jeton soit disponible, puis on
        // crée une copie de la requête HTTP que nous interceptons en ajoutant un en-tête
        // d'Authorization avec le jeton.
        switchMap(token => {
          // On crée un clone de la requête avec un nouvel en-tête
          const clone = request.clone({
            // On définit le nouvel en-tête
            setHeaders: {
              // On ajoute le jeton d'authentification à l'en-tête 'Authorization'
              'Authorization': `Bearer ${token}`
            }
          });
          // On laisse la requête modifiée continuer son chemin
          return next.handle(clone);
        })
      );
    }
  }
}
